// import {
//   Button,
//   Card,
//   CardHeader,
//   CardBody,
//   Row,
//   Col,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Spinner,
// } from "reactstrap";
// import { useParams } from "react-router-dom";
// import { useState, useRef, useEffect, useCallback, useMemo } from "react";
// import file_icon from "../../assets/img/file_icon.png";
// import pdf_icon from "../../assets/img/pdf_icon.png"; // ✅ Add this line at the top with imports
// import { URL } from "../../api";
// import axiosInstance from "../../Request";

// // Subcomponent for rendering individual documents
// const DocumentItem = ({ doc, onPreview }) => {
//   const path = doc.document_path?.toLowerCase() || "";
//   const cleanPath = path.split("?")[0];
//   const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(cleanPath);
//   const isPDF = /\.pdf$/i.test(cleanPath); // ✅ Detect PDF

//   // ✅ New detection for Excel and XML
//   const isExcel = /\.(xls|xlsx|csv)$/i.test(cleanPath);
//   const isXML = /\.xml$/i.test(cleanPath);

//   const isBankDoc = doc.document_name?.toLowerCase().includes("bank") || doc.document_type_id === 13;

// //   const handleClick = () => {
// //     // ✅ If it's Excel or XML, download/open instead of showing in Modal
// //     if (isExcel || isXML) {
// //       window.open(doc.document_path, "_blank");
// //     } else {
// //       onPreview(doc.document_path, isPDF);
// //     }
// //   };

// //   // const handleClick = () => {
// //   //   onPreview(doc.document_path, isPDF); // ✅ Trigger modal preview
// //   // };

// //   // return (
// //   //   <div style={{ marginRight: "10px", marginBottom: "10px", maxWidth: 256 }}>
// //   //     <img
// //   //       src={isImage ? doc.document_path : isPDF ? pdf_icon : file_icon} // ✅ Show pdf_icon for PDFs
// //   //       alt={doc.document_name}
// //   //       style={{
// //   //         maxWidth: "256px",
// //   //         maxHeight: "256px",
// //   //         cursor: "pointer",
// //   //         border: "1px solid #ccc",
// //   //         borderRadius: "4px",
// //   //         objectFit: "cover",
// //   //       }}
// //   //       onClick={handleClick}
// //   //     />
// //   //     {doc.document_name?.toLowerCase().includes("bank") && doc.password && (
// //   //       <div style={{ marginTop: "5px", fontSize: "0.9rem", color: "#333" }}>
// //   //         <strong>Password:</strong> {doc.password}
// //   //       </div>
// //   //     )}

// //   return (
// //     <div style={{ marginRight: "10px", marginBottom: "10px", maxWidth: 256 }}>
// //       <img
// //         // ✅ For Excel/XML, you can use file_icon or a specific icon
// //         src={isImage ? doc.document_path : isPDF ? pdf_icon : file_icon}
// //         alt={doc.document_name}
// //         style={{
// //           maxWidth: "256px",
// //           maxHeight: "256px",
// //           cursor: "pointer",
// //           border: "1px solid #ccc",
// //           borderRadius: "4px",
// //           objectFit: "cover",
// //           backgroundColor: "#f8f9fa" // Helpful for transparent icons
// //         }}
// //         onClick={handleClick}
// //       />
// //       {/* Existing metadata displays... */}
// //       <div style={{ fontSize: "0.8rem", wordBreak: "break-all", maxWidth: "256px" }}>
// //         {doc.document_name}
// //       </div>
// //       {doc.document_name?.toLowerCase().includes("bank") && doc.password && (
// //         <div style={{ marginTop: "5px", fontSize: "0.9rem", color: "#333" }}>
// //           <strong>Password:</strong> {doc.password}
// //         </div>
// //       )}

// //       {doc.document_type_id === 24 && doc.salary_slip_month && (
// //         <div style={{ marginTop: "5px", fontSize: "0.9rem", color: "#333" }}>
// //           <strong>Month:</strong> {doc.salary_slip_month}
// //         </div>
// //       )}
// //       {doc.document_type_id === 19 && doc.utility_bill_subtype && (
// //         <div style={{ marginTop: "5px", fontSize: "0.9rem", color: "#333" }}>
// //           <strong>Name:</strong> {doc.utility_bill_subtype}
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// const handleClick = () => {
//     // ✅ Trigger download/new tab for Excel and XML, Modal for others
//     if (isExcel || isXML) {
//       window.open(doc.document_path, "_blank");
//     } else {
//       onPreview(doc.document_path, isPDF);
//     }
//   };

//   return (
//     <div style={{ marginRight: "10px", marginBottom: "15px", width: "150px", display: "inline-block", verticalAlign: "top" }}>
//       <img
//         // ✅ Dynamically show PDF, Excel, or File icon based on extension
//         src={isImage ? doc.document_path : isPDF ? pdf_icon : file_icon}
//         alt={doc.document_name}
//         style={{
//           width: "150px",
//           height: "150px",
//           cursor: "pointer",
//           border: "1px solid #ccc",
//           borderRadius: "4px",
//           objectFit: "cover",
//           backgroundColor: "#f8f9fa"
//         }}
//         onClick={handleClick}
//       />

//       {/* ✅ SECTION UNDER NAMES: Only shows for Bank Documents */}
//       {isBankDoc && (
//         <div style={{ marginTop: "5px", textAlign: "left" }}>
//           <div style={{ fontSize: "0.75rem", fontWeight: "bold", wordBreak: "break-all", color: "#333" }}>
//             {doc.document_name}
//           </div>
//           {doc.password && (
//             <div style={{ fontSize: "0.7rem", color: "#d63384" }}>
//               <strong>Password:</strong> {doc.password}
//             </div>
//           )}
//         </div>
//       )}

//       {/* ✅ Keep other specific metadata for Salary/Utility if needed, 
//           otherwise it remains empty for ID Proof/PAN as requested */}
//       {!isBankDoc && (doc.salary_slip_month || doc.utility_bill_subtype) && (
//         <div style={{ marginTop: "5px", fontSize: "0.75rem" }}>
//           {doc.salary_slip_month && <div><strong>Month:</strong> {doc.salary_slip_month}</div>}
//           {doc.utility_bill_subtype && <div><strong>Name:</strong> {doc.utility_bill_subtype}</div>}
//         </div>
//       )}
//     </div>
//   );
// };

// const Profile = () => {
//   const { cid, lid, lead_id } = useParams();
//   const [customerDetails, setCustomerDetails] = useState({});
//   const [modal, setModal] = useState(false);
//   const [selectedDoc, setSelectedDoc] = useState({ src: null, isPDF: false }); // Store both src and type
//   const [rotation, setRotation] = useState(0);
//   const [uploadingStatus, setUploadingStatus] = useState({});
//   const fileInputRef = useRef(null);
//   const [uploadForIDProof, setUploadForIDProof] = useState(false);
//   const [uploadDocTypeId, setUploadDocTypeId] = useState(null);
//   const [pdfLoaded, setPdfLoaded] = useState(false); // Track PDF loading state

//   const typeMap = {
//     pan: 5,
//     aadhaar_front: 2,
//     aadhaar_back: 3,
//     selfie: 1,
//     bank: 13,
//     other: 22,
//     salary_slip: 24,
//     utility_bill: 19,
//   };

//   const categoryDisplayNames = {
//     pan: "ID Proof",
//     aadhaar_front: "Address Proof - Front",
//     aadhaar_back: "Address Proof - Back",
//     selfie: "Selfie",
//     bank: "Bank Documents",
//     salary_slip: "Salary Slip",
//     utility_bill: "Utility Bill",
//     other: "Other Documents",
//   };

//   const displayOrder = [
//     "pan",
//     "aadhaar_front",
//     "aadhaar_back",
//     "selfie",
//     "bank",
//     "salary_slip",
//     "utility_bill",
//     "other",
//   ];

//   const excludedDocs = ["pan_xml", "pan_pdf", "aadhaar_json", "pan_json"];

//   useEffect(() => {
//     fetchDocuments();
//   }, [cid , lid]);

// const fetchDocuments = useCallback(async () => {
//   try {
//     const response = await axiosInstance.get(
//       `${URL.GET_DOCUMENTS}?customer_id=${cid}&lead_id=${lid}`
//     );
//     setCustomerDetails(response.data || {});
//   } catch (error) {
//     console.error("Error fetching documents:", error);
//     setCustomerDetails({});
//   }
// }, [cid, lid]);


//   const handleFileChange = async (event) => {
//     const selectedFile = event.target.files[0];
//     if (!selectedFile) return;

//     const currentDocTypeId = uploadDocTypeId || 22;
//     // ✅ Determine if this type allows multiple (Bank=13, Other=22)
//     const allowsMultiple = currentDocTypeId === 13 || currentDocTypeId === 22;
//     setUploadingStatus((prev) => ({ ...prev, [currentDocTypeId]: true }));

//     // try {
//     //   const allDocs = Object.values(customerDetails).flat();
//     //   const existingDocs = allDocs.filter(
//     //     (doc) => doc.document_type_id === currentDocTypeId
//     //   );

//     //   if (existingDocs.length > 0) {
//     //     const moveResponse = await axiosInstance.post(
//     //       `${URL.UPDATE_DOCUMENT_TYPE}`,
//     //       {
//     //         customer_id: cid,
//     //         lead_id: lid,
//     //         documentTypeId: currentDocTypeId
//     //       }
//     //     );

//     //     if (moveResponse.status !== 200) throw new Error("Failed to move existing documents");
//     //   }

//     try {
//       // ✅ LOGIC CHANGE: Only move existing docs if category DOES NOT allow multiple
//       if (!allowsMultiple) {
//         const allDocs = Object.values(customerDetails).flat();
//         const existingDocs = allDocs.filter(
//           (doc) => doc.document_type_id === currentDocTypeId
//         );

//         if (existingDocs.length > 0) {
//           const moveResponse = await axiosInstance.post(
//             `${URL.UPDATE_DOCUMENT_TYPE}`,
//             {
//               customer_id: cid,
//               lead_id: lid,
//               documentTypeId: currentDocTypeId
//             }
//           );
//           if (moveResponse.status !== 200) throw new Error("Failed to move existing documents");
//         }
//       }

//       const formData = new FormData();
//       formData.append("file", selectedFile);
//       formData.append("documentTypeId", currentDocTypeId);
//       formData.append("customer_id", cid);
// if (lid && !isNaN(Number(lid))) {
//   formData.append("lead_id", Number(lid));
// }


// const uploadResponse = await axiosInstance.post(
//   `${URL.UPLOAD_DOCUMENT}`,
//   formData,
//   {
//     headers: { "Content-Type": "multipart/form-data" }
//   }
// );

// if (uploadResponse.status !== 200) {
//   throw new Error("Upload failed");
// }

// await fetchDocuments();
// alert("Document uploaded successfully");

//     } catch (error) {
//       console.error("Upload error:", error);
//       alert("Error uploading document");
//     } finally {
//       setUploadingStatus((prev) => ({ ...prev, [currentDocTypeId]: false }));
//       setUploadForIDProof(false);
//       setUploadDocTypeId(null);
//       if (fileInputRef.current) fileInputRef.current.value = "";
//     }
//   };

//   const handleUploadClick = (forIDProof = false, docTypeId) => {
//     setUploadForIDProof(forIDProof);
//     setUploadDocTypeId(docTypeId);
//     if (fileInputRef.current) fileInputRef.current.click();
//   };

//   const openDocPreviewModal = useCallback((src, isPDF) => {
//     setSelectedDoc({ src, isPDF });
//     setRotation(0);
//     setModal(true);
//     setPdfLoaded(false); // Reset PDF loaded state
//   }, []);

//   const closeDocPreviewModal = useCallback(() => {
//     setModal(false);
//     setSelectedDoc({ src: null, isPDF: false });
//     setRotation(0);
//     setPdfLoaded(false);
//   }, []);

//   const rotateImage = useCallback((direction) => {
//     setRotation((prev) => (direction === "left" ? prev - 90 : prev + 90));
//   }, []);

//   const allDocuments = useMemo(
//     () => Object.values(customerDetails || {}).flat(),
//     [customerDetails]
//   );

//   const filteredDocuments = useCallback(
//     (categoryFilter) => {
//       return allDocuments.filter((doc) => {
//         const name = (doc.document_name || "").toLowerCase();
//         const docTypeId = doc.document_type_id;
//         if (excludedDocs.includes(name)) return false;

//         switch (categoryFilter) {
//           case "pan":
//             return docTypeId === 5;
//           case "aadhaar_front":
//             return name.includes("aadhaar") && name.includes("front");
//           case "aadhaar_back":
//             return name.includes("aadhaar") && name.includes("back");
//           case "selfie":
//             return name.includes("selfie");
//           case "bank":
//             return name.includes("bank");
//           case "salary_slip":
//             return docTypeId === 24 || name.includes("salary");
//           case "utility_bill":
//             return docTypeId === 19 || name.includes("utility");
//           case "other":
//             return docTypeId === 22;
//           default:
//             return false;
//         }
//       });
//     },
//     [allDocuments]
//   );

//   const handleMaskClick = (category) => {
//     alert(`Mask button clicked for ${categoryDisplayNames[category]}`);
//   };

// //   return (
// //     <>
// //        <Modal isOpen={modal} toggle={closeDocPreviewModal} size="lg">
// //          <ModalHeader toggle={closeDocPreviewModal}>Document Preview</ModalHeader>
// //          <ModalBody style={{ height: "80vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
// //            {selectedDoc.isPDF ? (
// //             <embed
// //               src={`${selectedDoc.src}#toolbar=0&navpanes=0&scrollbar=0`}
// //               type="application/pdf"
// //               style={{ width: "100%", height: "100%", border: "none" }}
// //             />
// //           ) : (
// //             <img
// //               src={selectedDoc.src}
// //               alt="Preview"
// //               style={{ maxWidth: "100%", transform: `rotate(${rotation}deg)` }}
// //             />
// //           )}
// //         </ModalBody>
// //         <ModalFooter>
// //           {!selectedDoc.isPDF && (
// //             <>
// //               <Button color="primary" onClick={() => rotateImage("left")}>Rotate Left</Button>
// //               <Button color="primary" onClick={() => rotateImage("right")}>Rotate Right</Button>
// //             </>
// //           )}
// //           <Button color="secondary" onClick={closeDocPreviewModal}>Close</Button>
// //         </ModalFooter>
// //       </Modal>

// //       <Card className="bg-secondary shadow">
// //         <CardHeader className="bg-white border-0">
// //           <Row className="align-items-center">
// //             <Col xs="8">
// //               <h3 className="mb-0">Documents</h3>
// //             </Col>
// //           </Row>
// //         </CardHeader>
// //         <CardBody>
// //           <ul className="list-group">
// //             {displayOrder.map((category) => {
// //               const docs = filteredDocuments(category);
// //               const hasDocs = docs.length > 0;
// //               const docTypeId = typeMap[category] || 22;
// //               const isUploading = uploadingStatus[docTypeId];
// //               const isIDProof = category === "pan";
// //               const isAddressFront = category === "aadhaar_front";
// //               const isAddressBack = category === "aadhaar_back";

// //               return (
// //                 <li
// //                   key={category}
// //                   className="list-group-item border-0 p-4 mb-2 bg-gray-100 border-radius-lg"
// //                 >
// //                   <div className="d-flex justify-content-between align-items-start flex-wrap w-100">
// //                     <div className="d-flex flex-column">
// //                       <h6 className="mb-3 text-sm">{categoryDisplayNames[category]}</h6>
// //                       <div className="d-flex flex-wrap">
// //                         {hasDocs ? (
// //                           docs.map((doc, i) => (
// //                             <DocumentItem
// //                               key={i}
// //                               doc={doc}
// //                               onPreview={openDocPreviewModal}
// //                             />
// //                           ))
// //                         ) : (
// //                           <div
// //                             style={{
// //                               color: "#666",
// //                               fontStyle: "italic",
// //                               marginBottom: "10px",
// //                             }}
// //                           >
// //                             No documents uploaded.
// //                           </div>
// //                         )}
// //                       </div>
// //                     </div>
// //                     <div className="text-end d-flex align-items-center gap-2">
// //                       <input
// //                         ref={fileInputRef}
// //                         type="file"
// //                         style={{ display: "none" }}
// //                         onChange={handleFileChange}
// //                         accept="image/*,application/pdf"
// //                       />
// //                       {hasDocs && category !== "other" && (
// //                         <>
// //                           {(isIDProof || isAddressFront || isAddressBack) && (
// //                             <Button
// //                               color="warning"
// //                               size="sm"
// //                               onClick={() => handleMaskClick(category)}
// //                             >
// //                               Mask
// //                             </Button>
// //                           )}
// //                           <Button
// //                             color="primary"
// //                             size="sm"
// //                             onClick={() => handleUploadClick(isIDProof, docTypeId)}
// //                             disabled={isUploading}
// //                           >
// //                             {isUploading ? (
// //                               <>
// //                                 Changing... <Spinner size="sm" />
// //                               </>
// //                             ) : (
// //                               "Change"
// //                             )}
// //                           </Button>
// //                         </>
// //                       )}
// //                       {(!hasDocs || category === "other") && (
// //                         <Button
// //                           color="success"
// //                           size="sm"
// //                           onClick={() => handleUploadClick(isIDProof, docTypeId)}
// //                           disabled={isUploading}
// //                         >
// //                           {isUploading ? (
// //                             <>
// //                               Uploading... <Spinner size="sm" />
// //                             </>
// //                           ) : (
// //                             "Upload"
// //                           )}
// //                         </Button>
// //                       )}
// //                     </div>
// //                   </div>
// //                 </li>
// //               );
// //             })}
// //           </ul>
// //         </CardBody>
// //       </Card>

// //     </>
// //   );
// // };

// // return (
// //     <>
// //       <Modal isOpen={modal} toggle={closeDocPreviewModal} size="lg">
// //         <ModalHeader toggle={closeDocPreviewModal}>Document Preview</ModalHeader>
// //         <ModalBody style={{ height: "80vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
// //           {selectedDoc.isPDF ? (
// //             // ✅ Using iframe for better PDF stability
// //             <iframe
// //               src={`${selectedDoc.src}#toolbar=0`}
// //               title="PDF Preview"
// //               style={{ width: "100%", height: "100%", border: "none" }}
// //             />
// //           ) : (
// //             <img
// //               src={selectedDoc.src}
// //               alt="Preview"
// //               style={{ maxWidth: "100%", maxHeight: "100%", transform: `rotate(${rotation}deg)` }}
// //             />
// //           )}
// //         </ModalBody>
// //         <ModalFooter>
// //           {!selectedDoc.isPDF && (
// //             <>
// //               <Button color="primary" onClick={() => rotateImage("left")}>Rotate Left</Button>
// //               <Button color="primary" onClick={() => rotateImage("right")}>Rotate Right</Button>
// //             </>
// //           )}
// //           <Button color="secondary" onClick={closeDocPreviewModal}>Close</Button>
// //         </ModalFooter>
// //       </Modal>

// //       <Card className="bg-secondary shadow">
// //         <CardHeader className="bg-white border-0">
// //           <Row><Col><h3>Documents</h3></Col></Row>
// //         </CardHeader>
// //         <CardBody>
// //           <ul className="list-group">
// //             {displayOrder.map((category) => {
// //               const docs = filteredDocuments(category);
// //               const hasDocs = docs.length > 0;
// //               const docTypeId = typeMap[category] || 22;
// //               const isUploading = uploadingStatus[docTypeId];
// //               const isIDProof = category === "pan";
// //               const allowsMultiple = category === "other" || category === "bank";

// //               return (
// //                 <li key={category} className="list-group-item border-0 p-4 mb-2 bg-gray-100 border-radius-lg">
// //                   <div className="d-flex justify-content-between align-items-start flex-wrap w-100">
// //                     <div className="d-flex flex-column">
// //                       <h6 className="mb-3 text-sm">{categoryDisplayNames[category]}</h6>
// //                       <div className="d-flex flex-wrap">
// //                         {hasDocs ? (
// //                           docs.map((doc, i) => (
// //                             <DocumentItem key={i} doc={doc} onPreview={openDocPreviewModal} />
// //                           ))
// //                         ) : (
// //                           <div style={{ color: "#666", fontStyle: "italic", marginBottom: "10px" }}>No documents uploaded.</div>
// //                         )}
// //                       </div>
// //                     </div>

// //                     <div className="text-end d-flex align-items-center gap-2">
// //                       <input
// //                         ref={fileInputRef}
// //                         type="file"
// //                         style={{ display: "none" }}
// //                         onChange={handleFileChange}
// //                         accept="image/*,application/pdf,.xml,.xls,.xlsx,.csv"
// //                       />

// //                       {/* Only show Change button for Single-upload docs (PAN, Selfie, etc) */}
// //                       {hasDocs && !allowsMultiple && (
// //                         <Button
// //                           color="primary"
// //                           size="sm"
// //                           onClick={() => handleUploadClick(isIDProof, docTypeId)}
// //                           disabled={isUploading}
// //                         >
// //                           {isUploading ? <Spinner size="sm" /> : "Change"}
// //                         </Button>
// //                       )}

// //                       {/* Always show Upload More/Upload for Bank and Other */}
// //                       {(!hasDocs || allowsMultiple) && (
// //                         <Button
// //                           color="success"
// //                           size="sm"
// //                           onClick={() => handleUploadClick(isIDProof, docTypeId)}
// //                           disabled={isUploading}
// //                         >
// //                           {isUploading ? (
// //                              <><Spinner size="sm" /> Uploading...</>
// //                           ) : (
// //                             allowsMultiple && hasDocs ? "Upload More" : "Upload"
// //                           )}
// //                         </Button>
// //                       )}
// //                     </div>
// //                   </div>
// //                 </li>
// //               );
// //             })}
// //           </ul>
// //         </CardBody>
// //       </Card>
// //     </>
// //   );
// // };


// return (
//     <>
//       {/* Modal remains the same but uses iframe for PDF */}
//       <Modal isOpen={modal} toggle={closeDocPreviewModal} size="lg">
//          <ModalHeader toggle={closeDocPreviewModal}>Document Preview</ModalHeader>
//          <ModalBody style={{ height: "80vh", display: "flex", justifyContent: "center" }}>
//             {selectedDoc.isPDF ? (
//               <iframe src={selectedDoc.src} title="PDF" style={{ width: "100%", height: "100%", border: "none" }} />
//             ) : (
//               <img src={selectedDoc.src} alt="Preview" style={{ maxWidth: "100%", transform: `rotate(${rotation}deg)` }} />
//             )}
//          </ModalBody>
//          <ModalFooter>
//             {!selectedDoc.isPDF && <Button color="primary" onClick={() => rotateImage("right")}>Rotate</Button>}
//             <Button color="secondary" onClick={closeDocPreviewModal}>Close</Button>
//          </ModalFooter>
//       </Modal>

//       <Card className="bg-secondary shadow">
//         <CardHeader className="bg-white border-0">
//           <h3 className="mb-0">Documents</h3>
//         </CardHeader>
//         <CardBody>
//           <ul className="list-group">
//             {displayOrder.map((category) => {
//               const docs = filteredDocuments(category);
//               const hasDocs = docs.length > 0;
//               const docTypeId = typeMap[category] || 22;
//               const isUploading = uploadingStatus[docTypeId];
//               const isMultipleCategory = category === "bank" || category === "other";

//               return (
//                 <li key={category} className="list-group-item border-0 p-4 mb-2 bg-gray-100 border-radius-lg">
//                   <div className="d-flex justify-content-between align-items-start flex-wrap w-100">
//                     <div className="d-flex flex-column">
//                       <h6 className="mb-3 text-sm">{categoryDisplayNames[category]}</h6>
//                       <div className="d-flex flex-wrap">
//                         {hasDocs ? docs.map((doc, i) => (
//                           <DocumentItem key={i} doc={doc} onPreview={openDocPreviewModal} />
//                         )) : (
//                           <div className="text-muted italic small">No documents uploaded.</div>
//                         )}
//                       </div>
//                     </div>

//                     <div className="text-end d-flex align-items-center gap-2">
//                       <input 
//                         ref={fileInputRef} 
//                         type="file" 
//                         style={{ display: "none" }} 
//                         onChange={handleFileChange} 
//                         accept="image/*,application/pdf,.xml,.xls,.xlsx,.csv" 
//                       />
                      
//                       {/* ✅ "Change" button only for single files, "Upload More" for Bank/Other */}
//                       {hasDocs && !isMultipleCategory ? (
//                         <Button color="primary" size="sm" onClick={() => handleUploadClick(false, docTypeId)} disabled={isUploading}>
//                           {isUploading ? <Spinner size="sm" /> : "Change"}
//                         </Button>
//                       ) : (
//                         <Button color="success" size="sm" onClick={() => handleUploadClick(false, docTypeId)} disabled={isUploading}>
//                           {isUploading ? <Spinner size="sm" /> : (hasDocs ? "+ Upload More" : "Upload")}
//                         </Button>
//                       )}
//                     </div>
//                   </div>
//                 </li>
//               );
//             })}
//           </ul>
//         </CardBody>
//       </Card>
//     </>
//   );
// };
// export default Profile;

// // document section end 




import {
  Button, Card, CardHeader, CardBody, Row, Col, Badge, Input,
  Modal, ModalHeader, ModalBody, ModalFooter, Spinner,
} from "reactstrap";
import { useParams } from "react-router-dom";
import { useState, useRef, useEffect, useCallback, useMemo } from "react";
import file_icon from "../../assets/img/file_icon.png";
import pdf_icon from "../../assets/img/pdf_icon.png"; 
import { URL } from "../../api";
import axiosInstance from "../../Request";

const DocumentItem = ({ doc, onPreview }) => {
  const path = doc.document_path?.toLowerCase() || "";
  const cleanPath = path.split("?")[0];
  const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(cleanPath);
  const isPDF = /\.pdf$/i.test(cleanPath);
  const isExcel = /\.(xls|xlsx|csv)$/i.test(cleanPath);
  const isXML = /\.xml$/i.test(cleanPath);

  const handleClick = () => {
    // ✅ Direct open in new page for Excel and XML
    if (isExcel || isXML) {
      window.open(doc.document_path, "_blank");
    } else {
      // Open Modal for Images and PDFs
      onPreview(doc.document_path, isPDF);
    }
  };

  return (
    <div style={{ marginRight: "10px", marginBottom: "15px", width: "150px", display: "inline-block", verticalAlign: "top" }}>
      <img
        src={isImage ? doc.document_path : isPDF ? pdf_icon : file_icon}
        alt={doc.document_name}
        style={{
          width: "150px", height: "150px", cursor: "pointer",
          border: "1px solid #ccc", borderRadius: "4px",
          objectFit: "cover", backgroundColor: "#f8f9fa"
        }}
        onClick={handleClick}
      />
      {/* ✅ Bank statement labels and passwords have been removed from here */}
    </div>
  );
};

const Profile = () => {
  const { cid, lid } = useParams();
  const [customerDetails, setCustomerDetails] = useState({});
  const [modal, setModal] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState({ src: null, isPDF: false });
  const [rotation, setRotation] = useState(0);
  const [uploadingStatus, setUploadingStatus] = useState({});
  const fileInputRef = useRef(null);
  const [uploadDocTypeId, setUploadDocTypeId] = useState(null);
  // Documents shown one category at a time, chosen from a dropdown.
  const [selectedCat, setSelectedCat] = useState("pan");

  const typeMap = { pan: 5, aadhaar_front: 2, aadhaar_back: 3, selfie: 1, bank: 13, other: 22, salary_slip: 24, utility_bill: 19 };
  const categoryDisplayNames = { pan: "ID Proof", aadhaar_front: "Address Proof - Front", aadhaar_back: "Address Proof - Back", selfie: "Selfie", bank: "Bank Documents", salary_slip: "Salary Slip", utility_bill: "Utility Bill", other: "Other Documents" };
  const displayOrder = ["pan", "aadhaar_front", "aadhaar_back", "selfie", "bank", "salary_slip", "utility_bill", "other"];

  const fetchDocuments = useCallback(async () => {
    try {
      const response = await axiosInstance.get(`${URL.GET_DOCUMENTS}?customer_id=${cid}&lead_id=${lid}`);
      setCustomerDetails(response.data || {});
    } catch (error) { setCustomerDetails({}); }
  }, [cid, lid]);

  useEffect(() => { fetchDocuments(); }, [fetchDocuments]);

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    if (!window.confirm(`Are you sure you want to upload: ${selectedFile.name}?`)) {
      event.target.value = "";
      return;
    }

    const currentDocTypeId = uploadDocTypeId || 22;
    const allowsMultiple = currentDocTypeId === 13 || currentDocTypeId === 22;
    setUploadingStatus(prev => ({ ...prev, [currentDocTypeId]: true }));

    try {
      if (!allowsMultiple) {
        const allDocs = Object.values(customerDetails).flat();
        const existingDocs = allDocs.filter(d => d.document_type_id === currentDocTypeId);
        if (existingDocs.length > 0) {
          await axiosInstance.post(`${URL.UPDATE_DOCUMENT_TYPE}`, { customer_id: cid, lead_id: lid, documentTypeId: currentDocTypeId });
        }
      }

      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("documentTypeId", currentDocTypeId);
      formData.append("customer_id", cid);
      if (lid) formData.append("lead_id", Number(lid));

      await axiosInstance.post(`${URL.UPLOAD_DOCUMENT}`, formData, { headers: { "Content-Type": "multipart/form-data" } });
      await fetchDocuments();
      alert("Uploaded successfully");
    } catch (e) { alert("Upload error"); }
    finally {
      setUploadingStatus(prev => ({ ...prev, [currentDocTypeId]: false }));
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const openDocPreviewModal = (src, isPDF) => {
    setSelectedDoc({ src, isPDF });
    setRotation(0);
    setModal(true);
  };

  const allDocuments = useMemo(() => Object.values(customerDetails || {}).flat(), [customerDetails]);

  const filteredDocuments = useCallback((categoryFilter) => {
    return allDocuments.filter((doc) => {
      const name = (doc.document_name || "").toLowerCase();
      const docTypeId = doc.document_type_id;
      switch (categoryFilter) {
        // PAN card: normally value_id 5, but some are mis-saved as "other" (22) — also match by name.
        case "pan": return docTypeId === 5 || name.includes("pan_card");
        case "bank": return name.includes("bank") || docTypeId === 13;
        // "Other" must not swallow a mis-typed pan_card (now shown under ID Proof).
        case "other": return docTypeId === typeMap["other"] && !name.includes("pan_card");
        default: return docTypeId === typeMap[categoryFilter];
      }
    });
  }, [allDocuments, typeMap]);

  return (
    <>
      <Modal isOpen={modal} toggle={() => setModal(false)} size="lg">
        <ModalHeader toggle={() => setModal(false)}>Document Preview</ModalHeader>
        <ModalBody style={{ height: "75vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
          {selectedDoc.isPDF ? (
            <iframe src={selectedDoc.src} title="PDF" style={{ width: "100%", height: "100%", border: "none" }} />
          ) : (
            <img src={selectedDoc.src} alt="Preview" style={{ maxWidth: "100%", maxHeight: "100%", transform: `rotate(${rotation}deg)`, objectFit: 'contain' }} />
          )}
        </ModalBody>
        <ModalFooter>
          {!selectedDoc.isPDF && <Button color="primary" onClick={() => setRotation(r => r + 90)}>Rotate</Button>}
          <Button color="secondary" onClick={() => setModal(false)}>Close</Button>
        </ModalFooter>
      </Modal>

      <Card className="bg-secondary shadow">
        <CardHeader className="bg-white border-0"><h3 className="mb-0">Documents</h3></CardHeader>
        <CardBody>
          {(() => {
            const docs = filteredDocuments(selectedCat);
            const docTypeId = typeMap[selectedCat];
            const isMultiple = selectedCat === "bank" || selectedCat === "other";

            return (
              <>
                {/* Category dropdown selector */}
                <Row className="align-items-center mb-4">
                  <Col md="6">
                    <label className="form-control-label text-sm mb-1 d-block">Document Category</label>
                    <Input
                      type="select"
                      bsSize="sm"
                      value={selectedCat}
                      onChange={(e) => setSelectedCat(e.target.value)}
                    >
                      {displayOrder.map((cat) => (
                        <option key={cat} value={cat}>
                          {categoryDisplayNames[cat]} ({filteredDocuments(cat).length})
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col md="6" className="text-md-right mt-2 mt-md-0">
                    <Button
                      color={docs.length > 0 && !isMultiple ? "primary" : "success"}
                      size="sm"
                      onClick={() => { setUploadDocTypeId(docTypeId); fileInputRef.current.click(); }}
                    >
                      {uploadingStatus[docTypeId] ? <Spinner size="sm" /> : (docs.length > 0 && !isMultiple ? "Change" : "+ Upload")}
                    </Button>
                  </Col>
                </Row>

                {/* Selected category's documents */}
                <div className="p-3 bg-gray-100 border-radius-lg">
                  <h6 className="mb-3 text-sm">
                    {categoryDisplayNames[selectedCat]}
                    <Badge color={docs.length > 0 ? "primary" : "secondary"} pill className="ml-2">{docs.length}</Badge>
                  </h6>
                  <div className="d-flex flex-wrap">
                    {docs.length > 0 ? docs.map((doc, i) => (
                      <DocumentItem key={i} doc={doc} onPreview={openDocPreviewModal} />
                    )) : <div className="text-muted italic small">No documents uploaded.</div>}
                  </div>
                </div>
              </>
            );
          })()}
        </CardBody>
      </Card>
      <input ref={fileInputRef} type="file" style={{ display: "none" }} onChange={handleFileChange} accept=".xml,.xls,.xlsx,.csv,image/*,application/pdf" />
    </>
  );
};

export default Profile;